// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3M9qm","log":"ModalInventoryLogs_log__2uzjH","date":"ModalInventoryLogs_date__2arE8","userName":"ModalInventoryLogs_userName__1oMeu"};